import { ItemTypeMetadata, itemTypeMetadataToIcon, itemTypeMetadataToName, ToItemTypeMetadata } from "../../common-shared-module/model/dyn-form/form-metadata/item-type-metadata.enum";
import { DataSourceItemMetadata } from "../../common-shared-module/model/dyn-form/form-metadata/item/datasource-item-metadata.model";
import { ItemMetadata } from "../../common-shared-module/model/dyn-form/form-metadata/item/item-metadata.model";
import { MetadataFactory } from "../../common-shared-module/model/dyn-form/form-metadata/metadata.factory";
import { SectionMetadataService } from "../services/section-metadata/section-metadata.service";
import { DDElement } from "./dd-element.model";


export class MyTool implements DDElement {

    sectionMetadataService: SectionMetadataService | null = null
    _id: string = ""
    itemContent: ItemMetadata
    slotWgt: number = 1

    constructor(public typeData: ItemTypeMetadata, itemContent?: ItemMetadata) {
        this._id = "id" + Math.floor(Math.random() * 1000000)
        this.itemContent = itemContent ? itemContent : MetadataFactory.createItem(typeData)
    }

    id(): string {
        return this.itemContent.id
    }

    label(): string {
        return this.itemContent.fieldLabel
    }

    item(): ItemMetadata {
        return this.itemContent
    }

    removeDependencies(): ItemMetadata[] {
        if (this.sectionMetadataService && ToItemTypeMetadata(this.itemContent.type) == ItemTypeMetadata.Select) {
            let deps = this.sectionMetadataService.searchFamily(<DataSourceItemMetadata>this.itemContent)
            deps.forEach(p => {
                p.clear()
                p.parentSelectFieldName = null
            })
            return deps
        }

        return [this.itemContent]
    }

    clone(): DDElement {
        return new MyToolBuilder().slotWeight(this.slotWgt).type(this.typeData).sectionMetadataService(this.sectionMetadataService).build()
    }

    icon(): string {
        return itemTypeMetadataToIcon(this.typeData)
    }

    name(): string {
        return itemTypeMetadataToName(this.typeData)
    }

    type(): ItemTypeMetadata {
        return this.typeData
    }

    slotWeight(): number {
        return this.slotWgt
    }

}


export class MyToolBuilder {

    _sectionMetadataService: SectionMetadataService | null = null
    _itemContent: ItemMetadata | null | undefined = null
    _typeData: ItemTypeMetadata | null = null
    _slotWeight: number = 1


    sectionMetadataService(sectionMetadataService: SectionMetadataService | null): MyToolBuilder {
        this._sectionMetadataService = sectionMetadataService
        return this
    }

    itemContent(itemContent?: ItemMetadata): MyToolBuilder {
        this._itemContent = itemContent
        return this
    }

    type(typeData: ItemTypeMetadata): MyToolBuilder {
        this._typeData = typeData
        return this
    }

    slotWeight(slotWeight: number): MyToolBuilder {
        this._slotWeight = slotWeight
        return this
    }

    build(): MyTool {
        if (this._typeData == null) {
            throw new Error("Missing Type ")
        }

        let mt = new MyTool(this._typeData)
        if (this._itemContent != null) {
            mt.itemContent = this._itemContent
        }

        if (this._sectionMetadataService != null) {
            mt.sectionMetadataService = this._sectionMetadataService
        }

        mt.slotWgt = this._slotWeight
        return mt
    }

}


export class MyToolFactory {

    public static newTool(type: ItemTypeMetadata, sectionMetadataService: SectionMetadataService, itemContent?: ItemMetadata): MyTool {
        switch (type) {
            case ItemTypeMetadata.Text:
                return new MyTool(ItemTypeMetadata.Text, itemContent);
            case ItemTypeMetadata.Numeric:
                return new MyTool(ItemTypeMetadata.Numeric, itemContent)
            case ItemTypeMetadata.TextArea:
                return new MyToolBuilder().type(ItemTypeMetadata.TextArea).slotWeight(3).itemContent(itemContent).build()
            case ItemTypeMetadata.CheckBox:
                return new MyTool(ItemTypeMetadata.CheckBox, itemContent)
            case ItemTypeMetadata.MultiCheckBox:
                return new MyToolBuilder().type(ItemTypeMetadata.MultiCheckBox).itemContent(itemContent).slotWeight(3).build()
            case ItemTypeMetadata.Datepicker:
                return new MyTool(ItemTypeMetadata.Datepicker, itemContent);
            case ItemTypeMetadata.Time:
                return new MyTool(ItemTypeMetadata.Time, itemContent);
            case ItemTypeMetadata.Radio:
                return new MyToolBuilder().type(ItemTypeMetadata.Radio).itemContent(itemContent).slotWeight(3).build();
            case ItemTypeMetadata.Select:
                return new MyToolBuilder().type(ItemTypeMetadata.Select).itemContent(itemContent).sectionMetadataService(sectionMetadataService).build()
            case ItemTypeMetadata.Html:
                return new MyTool(ItemTypeMetadata.Html, itemContent)

        }
        return new MyTool(ItemTypeMetadata.Text);
    }

}